import * as yup from 'yup';

export const dsersCredentialSchema = yup.object().shape({
  email: yup
    .string()
    .email('Você precisa inserir um e-mail válido.')
    .required('Este campo é obrigatório.'),
  password: yup.string().required('Este campo é obrigatório.'),
});
